import { IAnalyticsConfiguration } from '../../../domain/analytics/analytics-configuration'
import { IPageConfiguration } from '../../../domain/conf/page'
import { IProviderConfig } from '../../common/provider-config'
import { IAd } from '../ad'
import { AdTarget } from '../targeting/target'

/**
 * Supported ad bidding providers.
 * NOTE: these are the accepted values for `ads.bidding[].client` page conf.
 */
export enum AdBiddingProvider {
    AMAZON = 'amazon',
    DISTRICT_M = 'districtm',
    INDEX_EXCHANGE = 'ix',
    SORTABLE = 'sortable'
}

export interface IAdServiceAdapter {
    ads: IAd[]
    adURI: string

    destroy(ads?: IAd[]): void
    registerAd(ad: IAd): void
    requestAds(ads?: IAd[]): void
    target(targets: AdTarget[]): void
}

export interface IAdBiddingAdapter extends IAdServiceAdapter {
    initializeBidding(confs: IAdBiddingProviderConfig[], adServer?: string, timeout?: string): void
}

export interface IAdBiddingProviderConfig extends IProviderConfig {
    /**
     * Name of bidding provider.
     */
    client: AdBiddingProvider
}

export interface IAdVerifierAdapter extends IAdServiceAdapter {
    initializeVerifier(conf: IProviderConfig): void
}

export interface ITagManagerAdapter extends IAdServiceAdapter {
    initializeTagManagers(confs: ITagManagerProviderConfig[], pageConf?: IPageConfiguration,
                          analyticsConf?: IAnalyticsConfiguration): void
}

/**
 * Supported tag manager providers.
 * NOTE: these are the accepted values for `ads.tags[].client` page conf.
 */
export enum TagManagerProvider {
    KRUX = 'krux'
}

export interface ITagManagerProviderConfig extends IProviderConfig {
    /**
     * Name of tag manager provider.
     */
    client: TagManagerProvider
}
